import { Text } from '@mote/ui'
import styled from '@xstyled/styled-components'

export const ScreenWaveLoader = () => {
  return (
    <Root>
      <BarsContainer>
        {[0, 0.3, 0.6, 0.3, 0].map((delay, index) => (
          <Bar
            animation={`animate-bar 1.2s linear infinite ${delay}s`}
            key={`${delay}-${index}`}
          />
        ))}
      </BarsContainer>
      <Text
        as='span'
        fontSize='xl'
        lineHeight='xl'
        fontWeight='normal'
        color='grey.d4'
        display='block'
        textAlign='center'
      >
        Just a motement ...
      </Text>
    </Root>
  )
}

const Root = styled.div({
  position: 'fixed',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100vw',
  height: '100vh',
  '@supports (height: -webkit-fill-available)': {
    height: '-webkit-fill-available'
  },
  background: '#ffffff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '1.5rem'
})

const BarsContainer = styled.div({
  height: 50,
  display: 'flex',
  alignItems: 'center',
  '@keyframes animate-bar': {
    '50%': {
      height: '20%'
    },
    '100%': {
      height: '100%'
    }
  }
})

const Bar = styled.spanBox(props => ({
  display: 'block',
  position: 'relative',
  background: props.theme.colors.primary.base,
  height: '100%',
  width: 8,
  borderRadius: '0.25rem',
  margin: '0 0.25rem'
}))
